module.exports = __webpack_public_path__ + "img/userC02.b3282b47.jpg";